import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { Subject, throwError } from 'rxjs';
import { catchError, map, publishReplay, refCount } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserFallService {
  error = new Subject<string>();
  slug = '/user_falls';
  resourceName = 'user_falls';
  allFalls?: any;
  fallsBetween?: any;

  constructor(private http: HttpClient) {}

  fetchAll(): any {
    if (!this.allFalls) {
      this.allFalls = this.http
        .get<any>(environment.apiUrl + this.slug, {
          responseType: 'json',
        })
        .pipe(
          map((responseData) => {
            const returnArray: any[] = [];
            responseData['_embedded'][this.resourceName].forEach(
              (item: any) => {
                returnArray.push(item);
              }
            );
            return returnArray;
          }),
          catchError((errorRes) => {
            return throwError(errorRes);
          }),
          publishReplay(1),
          refCount()
        );
    }

    return this.allFalls;
  }

  clearCache() {
    this.allFalls = null;
    this.fallsBetween = null;
  }

  fetch(id: number) {
    return this.http
      .get<any>(environment.apiUrl + this.slug + '/' + id, {
        responseType: 'json',
      })
      .pipe(
        map((responseData) => {
          return responseData;
        }),
        catchError((errorRes) => {
          return throwError(errorRes);
        })
      );
  }

  create(fall: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      fall,
    };
    return this.http.post<any>(environment.apiUrl + this.slug, payload, {
      observe: 'response',
    });
  }

  update(id: number, fall: string, date_recorded: string) {
    this.clearCache();
    const payload = {
      date_recorded: moment(date_recorded).format('YYYY-MM-DD'),
      fall,
    };
    return this.http.patch<any>(
      environment.apiUrl + this.slug + '/' + id,
      payload,
      {
        observe: 'response',
      }
    );
  }

  delete(id: number) {
    this.clearCache();
    return this.http.delete<{ name: string }>(
      environment.apiUrl + this.slug + '/' + id
    );
  }

  getRag(fall) {
    let ragColour = '';

    if (+fall == 0) {
      ragColour = 'green';
    } else if (+fall > 0 && +fall < 3) {
      ragColour = 'amber';
    } else {
      ragColour = 'red';
    }

    return ragColour;
  }

  getRangeforColor(colour: string) {
    let ragRange = '';
    if (colour == 'green') {
      ragRange = '0';
    } else if (colour == 'amber') {
      ragRange = '1-2';
    } else {
      ragRange = ' ≥3';
    }

    return ragRange;
  }
}
